import React from 'react'
import { WithErrorBoundary } from '../common/ErrorBoundary'

const LeadEditor = WithErrorBoundary(
  'Leads',
  'Error en Editor de Lead',
  React.lazy(() => import('./LeadEditor/LeadEditor')),
)

const HomeLeadsDashboardContainer = WithErrorBoundary(
  'Leads',
  'Error en Indicadores de Leads',
  React.lazy(() => import('./LeadDashboard/HomeLeadsDashboardContainer')),
)

const HomeLeadGroups = WithErrorBoundary(
  'Leads',
  'Error en Grupos de Leads',
  React.lazy(() => import('./LeadGroups/HomeLeadGroups')),
)

const HomeLeadAssignmentRules = WithErrorBoundary(
  'Leads',
  'Error en Reglas de asignación',
  React.lazy(() => import('./LeadAssignmentRules/HomeLeadAssignmentRules')),
)

const HomeCampaign = WithErrorBoundary(
  'Leads',
  'Error en Campañas',
  React.lazy(() => import('./Campaign/HomeCampaign')),
)

const CreateCampaign = WithErrorBoundary(
  'Leads',
  'Error en Crear campaña',
  React.lazy(() => import('./Campaign/CreateCampaign/CreateCampaignLayout')),
)

const Dashboard = WithErrorBoundary(
  'Leads',
  'Error en Tablero de leads',
  React.lazy(() => import('./Dashboard/Dashboard')),
)

const ListLeadsHandler = WithErrorBoundary(
  'Leads',
  'Error en Lista de Leads',
  React.lazy(() => import('./ListLeadsHandler')),
)

const LeadsMassiveUploadHome = WithErrorBoundary(
  'Leads',
  'Error en carga masiva de leads',
  React.lazy(() => import('./LeadsMassiveUpload/LeadsMassiveUploadHome')),
)

export default {
  path: '/gestor-leads',
  name: 'Gestor de leads',
  childRoutes: [
    { path: 'tablero-leads', name: 'Tablero de leads', component: Dashboard },
    { path: 'lista', name: 'Listado de leads', component: ListLeadsHandler, isIndex: true },
    { path: 'lista/crear-leads-masivos', name: 'Crear leads masivos', component: LeadsMassiveUploadHome },
    { path: 'editar/:id', name: 'Editar Lead', component: LeadEditor },
    { path: 'indicadores', name: 'Indicadores', component: HomeLeadsDashboardContainer },
    { path: 'grupos', name: 'Grupos', component: HomeLeadGroups },
    { path: 'reglas', name: 'Reglas de asignación', component: HomeLeadAssignmentRules },
    { path: 'campanias', name: 'Campañas', component: HomeCampaign },
    { path: 'campanias/crear', name: 'Crear campaña', component: CreateCampaign }
  ],
}
